/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItems_viewer$ref = any;
export type CartLayout_viewer$ref = any;
export type CartLayout_viewer = {
    readonly userRelationships?: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<({
            readonly displayName?: string | null;
            readonly phoneNumber?: string | null;
            readonly email?: string | null;
        } & ({
            readonly displayName: string | null;
            readonly phoneNumber: string | null;
            readonly email: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": CartItems_viewer$ref;
    readonly " $refType": CartLayout_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartLayout_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": "[String]!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartItems_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userRelationships",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "relationshipType",
                            "value": "VIP"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIds",
                            "variableName": "userIds"
                        }
                    ],
                    "concreteType": "UserRelationship",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userDataB",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "type": "VipRepData",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "phoneNumber",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "formatType",
                                                    "value": "INTERNATIONAL"
                                                }
                                            ],
                                            "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "email",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '173c52e27fb87677513252be9a65ce3a';
export default node;
